import React from 'react'
import { withRouter } from "react-router-dom";
import Od from './Od';
import TableComponent, { TableOp } from '../../../components/table/TableOps';
import ACCESS from '../../../ACCESS';

class Ods extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'od/filter', deleteUrl: 'od/delete', deleteField: 'destino_nombre', modUrl: '/Catalogo/OrigenDestino' },
      TableOp.Table('Orígenes - destinos', [
        { label: 'Clave de origen', id: 'origen' },
        { label: 'Origen', id: 'origen_nombre' },
        { label: 'Clave de destino', id: 'destino' },
        { label: 'Destino', id: 'destino_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_ORIGENES.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_ORIGENES.ELIMINAR_CATALOGO] },
      ])
    );
    this.table();
  }

  render() {
    return (
      <div>
        <div>
        {
           
          <Od  onSave={() => { this.table() }}></Od>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }


  // state = {
  //   table: TableOp.Table('Orígenes - destinos', [
  //     { label: 'Clave de origen', id: 'origen' },
  //     { label: 'Origen', id: 'origen_nombre' },
  //     { label: 'Clave de destino', id: 'destino' },
  //     { label: 'Destino', id: 'destino_nombre' },
  //   ], [
  //     { id: 'edit', icon: 'edit' },
  //     { id: 'delete', icon: 'delete' },
  //   ]),
  //   dialog: {}
  // }

  // componentDidMount() {
  //   this.cargarOds();
  // }

  // cargarOds = async (page = 0, limit = 5) => {
  //   let Res = await Http.get(`ods/filter?p=${page}&l=${limit}`);
  //   // console.log(Res);

  //   this.setState({ table: { ...this.state.table, rows: Res.data.rows, total: Res.data.total } });
  // }

  // eliminar = async (row) => {
  //   this.deleteRow = row;
  //   this.setState({
  //     dialog: {
  //       title: `¿Borrar el registro ${row.origen_nombre} - ${row.destino_nombre}?`,
  //       body: '',
  //       options: ['Sí', 'No'],
  //       show: true,
  //     }
  //   })
  // }

  // dialogClose = async (op) => {
  //   this.setState({ dialog: { ...this.state.dialog, show: false } })
  //   if (op === 1) {
  //     let Res = await Http.post('od/delete', this.deleteRow);
  //     if (!Res.error) {
  //       this.cargarOds();
  //     }
  //   }
  // }

  // action = (id, row) => {
  //   if (id === 'edit') {
  //     this.props.history.push(`/Catalogos/OrigenDestino/${row.id}`)
  //   }
  //   else if (id === 'delete') {
  //     this.eliminar(row)
  //   }
  // }

  // pag = (page, rpp) => {
  //   this.cargarOds(page, rpp);
  // }

  // render() {
  //   return (
  //     <div>
  //       <Od></Od>
  //       <div className="table-box">
  //         <Table table={this.state.table} onAction={this.action} pag={this.pag}></Table>
  //         <Dialog dialog={this.state.dialog} onClose={this.dialogClose} />
  //       </div>
  //     </div>
  //   )
  // }
}

export default withRouter(Ods)